let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("34Qbm")).then(() => parcelRequire('6LMXR'));